

import React, { useState, useEffect } from 'react'
import { Link } from "react-router-dom";
import { Col, Row, Input } from "antd";
import backButton from '../../../assets/images/back_button_arrow.svg';
import axios from "axios";
import { notifysuccess } from "../../../utils/toast";
import { notifyfailure } from "../../../utils/toast";
import { notifycatch } from "../../../utils/toast";
import Cookies from "js-cookie";
import configData from "../../../config/config.json";
import loaderIcon from "../../../assets/images/login-and-signup/loader.gif";
import listbreadcrumbsIcon from '../../../assets/images/icons/list_breadcrumbs.svg';
import uploadIcon from '../../../assets/images/icons/upload-cloud.svg';
import deleteIcon from '../../../assets/images/icons/trash.svg';
import csvIcon from '../../../assets/images/icons/csv.svg';
import txtIcon from '../../../assets/images/icons/txt.svg';

const AppBundleCreate = ({ handlePageViewChange, mode, fileViewId, fileViewName, fileViewExt }) => {


    // //////////////////////////////////////////////////////////////
    useEffect(() => {
        if (mode === "edit") {

            setName(fileViewName)
            setFile({
                data: "",
                filename: fileViewName,
                type: fileViewExt === "txt" ? "text/plain" : "text/csv",
                size: ""
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const [buttonProcessing, setButtonProcessing] = useState(false);

    const [toggleData, setToggleData] = useState(
        Math.floor(Math.random() * 90000) + 10000
    );


    const [name, setName] = useState("");
    const [nameIsRequiredError, setNameIsRequiredError] = useState(false);

    function onChangeName(event) {
        setNameIsRequiredError(false);
        setName(event.target.value);
        if (event.target.value.trim().length === 0) {
            setNameIsRequiredError(true)
        }
        else {
            setNameIsRequiredError(false)
        }
    }

    function onBlurName(event) {
        setName(event.target.value.trim())
    }


    const [file, setFile] = useState({
        data: "",
        filename: "",
        type: "",
        size: ""
    });
    const [fileIsRequiredError, setFileIsRequiredError] = useState(false);
    // const [fileValidError, setFileValidError] = useState(false);
    // const [fileValidErrorMsg, setFileValidErrorMsg] = useState("");

    function onChangeFile(e) {
        if (e.target.files[0]) {

            setFileIsRequiredError(false)

            if (
                e.target.files[0].size / (1024 * 1024) <= 100 &&
                (e.target.files[0].type === "text/plain" || e.target.files[0].type === "text/csv")
            ) {

                setFile({
                    data: e.target.files[0],
                    filename: e.target.files[0].name,
                    type: e.target.files[0].type,
                    size: e.target.files[0].size / (1024 * 1024)
                })

                // setFileValidError(false)
                // fileValidErrorMsg("")

            }
            else {
                if (e.target.files[0].size / (1024 * 1024) > 100) {
                    // setFileValidError(true)
                    // setFileValidErrorMsg("File should be less than 100 mb")
                    notifyfailure("File should be less than 100 mb")
                }

                else if (!(e.target.files[0].type === "text/plain" || e.target.files[0].type === "text/csv")) {
                    // setFileValidError(true)
                    // setFileValidErrorMsg("File should be in either txt or csv format")
                    notifyfailure("File should be in either txt or csv format")
                }
            }



        }
    }


    const handleSubmit = async (e) => {
        e.preventDefault();

        if (
            name.trim() !== "" &&
            file.filename !== ""
        ) {
            if (
                nameIsRequiredError === false &&
                fileIsRequiredError === false
            ) {


                let formData = new FormData();


                formData.append("name", name);
                formData.append('file', file.data);

                let status = Cookies.get("token_xapads_ssp") ? true : false;
                if (status) {

                    setButtonProcessing(true);
                    let token = Cookies.get("token_xapads_ssp");

                    if (mode === "create") {
                        axios
                            .post(configData.SERVER_URL + `ops/gam/uploadAppBundle`, formData, {
                                headers: {
                                    "Content-Type": "multipart/form-data",
                                    "x-access-token": token,
                                }
                            }
                            )
                            .then((response) => {
                                notifysuccess(response.data.message)
                                localStorage.setItem("appBundleReload", toggleData);
                                setToggleData(Math.floor(Math.random() * 90000) + 10000);


                                setTimeout(() => {
                                    localStorage.removeItem("appBundleReload");

                                    handlePageViewChange("table", "yes")
                                }, 1500)

                            })
                            .catch((error) => {
                                if (error?.response) {
                                    if (error.response.data.message?.length !== 0) {
                                        notifyfailure(error.response.data.message);
                                    }
                                } else {
                                    notifycatch();
                                }
                                setButtonProcessing(false)
                            });
                    }
                    else {

                        axios
                            .put(configData.SERVER_URL + `ops/gam/updateAppBundle?id=` + fileViewId, formData, {
                                headers: {
                                    "Content-Type": "multipart/form-data",
                                    "x-access-token": token,
                                }
                            }
                            )
                            .then((response) => {
                                notifysuccess(response.data.message)
                                localStorage.setItem("appBundleReload", toggleData);
                                setToggleData(Math.floor(Math.random() * 90000) + 10000);


                                setTimeout(() => {
                                    localStorage.removeItem("appBundleReload");

                                    handlePageViewChange("table", "yes")
                                }, 1500)

                            })
                            .catch((error) => {
                                if (error?.response) {
                                    if (error.response.data.message?.length !== 0) {
                                        notifyfailure(error.response.data.message);
                                    }
                                } else {
                                    notifycatch();
                                }
                                setButtonProcessing(false)
                            });

                    }

                }
            }
        } else {
            if (name.trim() === "") {
                setNameIsRequiredError(true);
            }
            if (file.filename === "") {
                setFileIsRequiredError(true);
            }
        }
    };

    return (
        <>
            <div className="container_box--wrapper pt_header">
                <div className="container_box--breadcrumb">
                    <ul className="container_box--breadcrumb-list">

                        <li >
                            <img src={listbreadcrumbsIcon} alt='USP' />
                            List Manager

                        </li>
                        <li>
                            <Link onClick={() => {
                                handlePageViewChange("table", "no")
                            }}>

                                App Bundle List
                            </Link>
                        </li>
                        <li className="primary"> {mode === "edit" ? <>Edit </> : <>Create </>} App Bundle List</li>
                    </ul>
                </div>
                <div className="container_box--wrapper--title d_flex justify-content-between">
                    <div className="back_btn_d2">
                        <img src={backButton} className="img-fluid" alt=""
                            onClick={() => {
                                handlePageViewChange("table", "no")

                            }}
                        />
                        <h1 className="heading">
                            {mode === "edit" ? <>{fileViewName} ({fileViewId})</> : <>Create App Bundle List</>}
                        </h1>
                    </div>
                </div>

                <div className="container_box--content pt_20 form_scrollable_div_d2">
                    <div className="container_box--width">

                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>List Details</label>
                                </div>
                            </Col>

                            <Col span={16}>
                                <div className="container_box--form-container">

                                    <Row gutter={16}>
                                        <Col span={24}>

                                            <div className="form_content_block--group hide_caret_after_select_value">
                                                <label className="form_label">Name *</label>
                                                <Input
                                                    className={nameIsRequiredError ? 'form_control basic error' : 'form_control basic '}
                                                    placeholder='' autocomplete="off"
                                                    value={name}
                                                    onChange={onChangeName}
                                                    onBlur={onBlurName}
                                                />
                                                <span className="error_content"> {nameIsRequiredError && <>  This field is required</>}</span>
                                            </div>
                                            <div className="form_content_block--group mb-0">
                                                <label className="form_label"> App Bundle * </label>
                                                <label for='fileip01' className='ant_upload_drag'>
                                                    <p className="upload_drag_icon"> <img src={uploadIcon} alt='USP' /></p>
                                                    <p className="ant_upload_text"><b className="primary">Click to upload</b> or drag and drop</p>
                                                    <p className="ant_upload_hint"> TXT or CSV (max. 100 MB) </p>
                                                </label>
                                                <input className='form_upload d-none' type="file" id="fileip01" name="fileip01"
                                                    onChange={onChangeFile}
                                                />
                                                <span className="error_content"> {fileIsRequiredError && <>  This field is required</>}
                                                    {/* {fileValidError && <>  {fileValidErrorMsg}</>} */}
                                                </span>
                                            </div>
                                            {file?.filename !== "" &&
                                                <div className="ant_upload_list--item mb-0 mt-4">
                                                    <div className="ant_upload_list--content">
                                                        {file.type !== "" ? <>
                                                            {file.type === "text/plain" ?
                                                                <img src={txtIcon} alt="USP" />
                                                                :
                                                                <img src={csvIcon} alt="USP" />

                                                            }
                                                        </> : <></>}

                                                        <div className="ant_upload_list--info">
                                                            <span className="ant_upload_list--info-name">{file.filename}</span>
                                                            {/* <span className="ant_upload_list--info-size">{file.size !== "" ? <>{file.size?.toFixed(2)}  MB</> : <></>}</span> */}
                                                            <span className="ant_upload_list--info-size">{file.size !== "" ?
                                                                file.size < 1 ?
                                                                    (file.size * 1024) < 1 ?
                                                                        <>{(file.size * 1024 * 1024)} Bytes </> :
                                                                        <>{(file.size * 1024)?.toFixed(2)} KB </> :
                                                                    <>{file.size?.toFixed(2)}  MB</> :
                                                                <></>}</span>
                                                        </div>
                                                    </div>
                                                    <button type="link" className="ant_upload_list--delete download_icon_d2"
                                                        onClick={() => {
                                                            setFile({
                                                                data: "",
                                                                filename: "",
                                                                ext: "",
                                                                size: ""
                                                            })

                                                            const fileInput00 = document.getElementById("fileip01");
                                                            fileInput00.value = "";

                                                        }}
                                                    >
                                                        <img src={deleteIcon} alt="USP" />
                                                    </button>
                                                </div>
                                            }
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </div >
                    <div className="hr_custom mb_20"></div>
                    <div className="btn_group justify-content-end gap_8 pb_50">
                        {buttonProcessing ?
                            <>
                                <button className="w_120_d2 btn btn_white_outline w_fit_content"
                                    disabled
                                >
                                    Discard
                                </button>
                                <button
                                    className="w_120_d2 btn btn_primary w_fit_content loader"

                                >
                                    <span>Submit</span>

                                    <img
                                        src={loaderIcon}
                                        alt="USP"
                                        className="loader_icon"
                                    />
                                </button>
                            </> :
                            <>
                                <button className="w_120_d2 btn btn_white_outline w_fit_content" onClick={() => { handlePageViewChange("table", "no") }}> Discard </button>
                                <button className="w_120_d2 btn btn_primary w_fit_content" onClick={handleSubmit}>{mode === "edit" ? <>Update</> : <>Submit</>}</button>
                            </>
                        }
                    </div>

                </div >

            </div>
        </>
    )
}

export default AppBundleCreate
